import { axiosInstance } from "@/services/axiosInstance";

// https://acquire-services-001.azurewebsites.net/api/v1/salechannel/settingsbydomain/pairs.alphapay.com.br
export const WhiteLabelResource = {
  get: parametros => {
    return axiosInstance.get("v1/salechannel/settingsbydomain/:url", {
      urlParams: parametros
    });
  }
};
